import React from 'react';

import { NotificationInstance } from 'antd/es/notification/interface';
import { LockOutlined } from '@ant-design/icons';

import { Permission, enumLabel } from '@src/enums/permission';

import SecurityRestrictionControl from '@controls/security-restriction/security-restriction-control';

const duration: number = 15;

export const securityRestriction = (api: NotificationInstance, permissions: Array<Permission> = []) => {
    const permissionLabel = permissions.map((p) => {
        return enumLabel(p);
    });

    api.open({
        title: 'Ограничение безопасности',
        placement: 'bottomRight',
        description: <SecurityRestrictionControl message={'Извините, у вас нет прав доступа'} permissionLabel={permissionLabel} />,
        duration: duration,
        icon: <LockOutlined />,
        style: { width: 600 },
    });
};
